import api from './client'

export const giftCardsApi = {
  listar: (params = {}) => api.get('/gift-cards', { params }),
  resumen: () => api.get('/gift-cards/resumen'),
  upside: () => api.get('/gift-cards/upside'),
  obtener: (id) => api.get(`/gift-cards/${id}`),
  crear: (data) => api.post('/gift-cards', data),
  crearLote: (data) => api.post('/gift-cards/lote', data),
  pdfLoteUrl: (ids) => `/gift-cards/pdf-lote?ids=${ids.join(',')}`,
  actualizar: (id, data) => api.put(`/gift-cards/${id}`, data),
  validar: (codigo) => api.get('/gift-cards/validar', { params: { codigo } }),
  canjear: (data) => api.post('/gift-cards/canjear', data),
  quitarCanje: (canjeId) => api.delete(`/gift-cards/canjes/${canjeId}`),
  porNV: (nvId) => api.get(`/gift-cards/por-nv/${nvId}`),
  guardarMetaNV: (nvId, tarjetas) => api.put(`/gift-cards/nv/${nvId}/meta`, { tarjetas }),
  crearNV: (id, data = {}) => api.post(`/gift-cards/${id}/crear-nv`, data),
  // ✉️ Cargar destinatario y mandar/reenviar (sug #87/#88): activa sale ya, pendiente al acreditarse.
  mandar: (id, email, nombre = null) => api.post(`/gift-cards/${id}/mandar`, { email, nombre }),
  anular: (id, motivo) => api.post(`/gift-cards/${id}/anular`, { motivo }),
  extender: (id, venceEl) => api.post(`/gift-cards/${id}/extender`, { vence_el: venceEl }),
  // Heredadas de Magento (solo super admin): listado y habilitar/deshabilitar el canje.
  heredadas: (params = {}) => api.get('/gift-cards/heredadas', { params }),
  habilitarHeredada: (id, habilitada) => api.post(`/gift-cards/heredadas/${id}/habilitar`, { habilitada }),
}
